
import React from 'react'

const Categories = ({ categories = [] }) => {
  return (
    <div className="our-services section-pad-t30">
      <div className="container">
        {/* Section Title */}
        <div className="row">
          <div className="col-lg-12">
            <div className="section-tittle text-center">
              <span>FEATURED CATEGORIES</span>
              <h2>Browse Top Categories</h2>
            </div>
          </div>
        </div>

        {/* Categories List */}
        <div style={{cursor: "pointer"}} className="row d-flex justify-content-center">
          {categories.map((cat, index) => (
            <div key={index} className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
              <div onClick={() => window.location.href = cat.link} className="single-services text-center mb-30">
                <div className="services-ion">
                  <span className={cat.icon}></span>
                </div>
                <div className="services-cap">
                  <h5><a href={cat.link}>{cat.title}</a></h5>
                  <span>({cat.count || 0})</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Browse All Button */}
        <div className="row">
          <div className="col-lg-12">
            <div className="browse-btn2 text-center mt-50">
              <a href="/opportunity-listings/all" className="border-btn2">Browse All Sectors</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Categories
